import { useEffect } from 'react';
import { trackRescuePageView } from '../analytics';

/**
 * Fires a "Rescue Portal Page Viewed" event once on mount for rescue routes
 * that render outside RescuePortal (e.g. /rescue/login, /rescue/terms). The
 * router-level tracker in RescuePortal.tsx only covers routes mounted inside
 * the portal shell, so those pages would otherwise never emit the event.
 *
 * `enabled` lets a caller skip tracking for a mount that immediately redirects
 * away — e.g. an already-logged-in user hitting /rescue/login.
 */
export default function useTrackRescuePageView(pagePath: string, pageTitle: string, enabled = true) {
  useEffect(() => {
    if (!enabled) {
      return;
    }
    trackRescuePageView(pagePath, pageTitle);
  }, [enabled, pagePath, pageTitle]);
}
